// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ServiceabilityRepoConfig from "./ServiceabilityRepoConfig.bs.js";

var dummyHelperResponse = {
      "sessions": [{
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": "2019-06-01",
        "status": "active"
      }
      ],
      "offset_value": 0
    };

var dummyResponseOutStation = {
      "sessions": [{
        "start_date_time": "2020-06-18T14:44:27.190+05:30",
        "end_date_time": "2019-06-01",
        "status": "active"
      },
      {
        "start_date_time": "2019-06-01",
        "end_date_time": null,
        "status": "active"
      }],
      "offset_value": 0
    };

var dummyRentalResponse = {
      "sessions":[{
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        },
        {
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        },
        {
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        },
        {
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        },
        {
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        },
        {
        "start_date_time":"2022-12-02T18:11:51.175+05:30",
        "end_date_time":"2022-12-02T18:12:02.493+05:30",
        "status":"inactive"
        }
      ],
      "offset_value": 0
    };

function getHelperServiceabilityInfo(_msisdn, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyHelperResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.HelperServiceabilityResponseConverter.execute, result);
                        });
            });
}

function getOutStationServiceabilityInfo(_msisdn, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyResponseOutStation
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.OutStationServiceabilityResponseConverter.execute, result);
                        });
            });
}

function getRentalServiceabilityInfo(_msisdn, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRentalResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.RentalServiceabilityResponseConverter.execute, result);
                        });
            });
}

function fetchHelperLabourServiceability(_msisdn, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyHelperResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ServiceabilityRepoConfig.HelperLabourServiceabilityResponseConverter.execute, result);
                        });
            });
}

var ServiceabilityRepo = {
  getHelperServiceabilityInfo: getHelperServiceabilityInfo,
  getOutStationServiceabilityInfo: getOutStationServiceabilityInfo,
  fetchHelperLabourServiceability: fetchHelperLabourServiceability,
  getRentalServiceabilityInfo: getRentalServiceabilityInfo
};

export {
  dummyHelperResponse ,
  dummyResponseOutStation ,
  dummyRentalResponse ,
  ServiceabilityRepo ,
  
}
/* ServiceabilityRepoConfig Not a pure module */
